module.exports = __webpack_public_path__ + "static/media/corefactors.820199c7.jpg";